<template>
    <div>
        <div 
        v-if="settings.display_progress_bar || show"
        class="progress rounded-0"
        :class="progressClass"
        :style="'height:'+height+'px'">

            <div 
            class="progress-bar" 
            :class="theme"
            role="progressbar" 
            :style="'width:'+value+'%'" 
            :aria-valuenow="value" 
            aria-valuemin="0" 
            aria-valuemax="100">

                <span v-if="!light">
                    {{value}}%
                </span>

            </div> <!-- /.progress-bar -->

        </div> <!-- /.progress -->

    </div>
</template>

<script>

    import {mapState, mapGetters} from 'vuex'

    export default {
        
        props: {

            show: {
                type: Boolean,
                default: false
            },

            light: {
                type: Boolean,
                default: false
            },

            theme: {
                type: String,
                default: 'bg-black'
            },

            progressClass: {
                type: String,
                default: ''
            },

            section: {
                type: Number,
                default: null
            }
        },

        computed: {

            ...mapState({
                settings: state => state.form.settings
            }),

            ...mapGetters('form', [
                'progress',
                'answers'
            ]),

            height() {
                return this.light ? 4 : 16
            },

            value() {
                return this.section 
                ? this.progress.sections[this.section].percentage
                : this.progress.percentage
            }
        },


    }
</script>